/*
 * The app's ONE session — who the user is, and what their org bought.
 *
 * The Session itself is base-ui's and shared by every Vitesse UI; this module is
 * where THIS app claims it, naming the surface it renders. That is the only part
 * that legitimately differs per app: an authored grant is scoped by surface, so
 * "may write from the app but not through the AI" is expressible.
 *
 * It lives here rather than in main/index.ts so a component can import it without
 * importing the boot module — importing boot from a component is a cycle, and the
 * usual way that gets "solved" is by not gating the component at all.
 *
 * ONE `initSession` call per app, and this is it. Identity is bound at boot with
 * `bindIdentity`, the plan arrives from SessionEntitlements.Subscribe; see
 * main/index.ts. Most components need neither — `<vitesse-gated>` resolves the same
 * session on its own, so wrapping is enough. This is for code that asks Session
 * questions directly.
 */
import { initSession, setGrantMatrixProvider } from '@vitesse/base-ui';

export const session = initSession();

// ─── TEMPORARY — Step 9 manual gating tests. Delete before committing. ───
// Stands in for the fleet-control grant provider that identity.ts's
// TODO(grant-matrix) is waiting on. Console: grants({ 'integration:delete': false })
let testGrants: Record<string, boolean> | undefined;
setGrantMatrixProvider(() => testGrants);
(window as unknown as { grants: (g?: Record<string, boolean>) => void }).grants = (g) => {
  testGrants = g;
  session.setIdentity({ ...session.identity, grants: g });
};

